<template>
    <header id="siteHeader" class="svgContainer" :class="[MutableIsActive ? 'is-active' : '']">
        <div class="pillInteraction" ref="pillInteraction" @mouseenter="onEnter" @mousedown="onMouseDown" @mouseup="onMouseUp" @touchstart="onTouchStart" @touchend="onTouchEnd" :class="[MutableIsActive ? '' : 'is-small']"></div>
        <div class="appearence"  :class="[MutableIsActive ? '' : 'is-small']">
            <svg  @mouseleave="onLeave" ref="svgPill" @touchend="onTouchEndOutside" class="svgPill" :class="[MutableIsActive ? '' : 'is-small', MutableIsPushed ? 'is-pushed' : '']" viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g class="savior">
                    <g class="circleMenu" >
                        <g transform="translate(15, 15)">
                            <path class="path-grab" id="siteHeaderPath" fill="transparent" d="M100,50A50,50,0,1,1,50,0,50,50,0,0,1,100,50Z" />
                            <text :textLength="'180px'" :lengthAdjust="'spacing'">
                                <textPath href="#siteHeaderPath" xlink:href="#siteHeaderPath">
                                    <!-- <tspan class="no-pointer star">&#8201;✳&#8201;</tspan> -->
                                    <tspan><router-link to="/" :xlink:href="'/'" :letter-spacing="'-0.5'">Home</router-link></tspan>
                                    <tspan class="no-pointer star">&#8201;•&#8201;</tspan>
                                    <tspan><router-link to="/exhibitions" :xlink:href="'/exhibitions'" :letter-spacing="'-0.5'">Exhibitions</router-link></tspan>
                                    <tspan class="no-pointer star">&#8201;•&#8201;</tspan>
                                    <!-- <tspan><router-link to="/publications" :xlink:href="'/publications'" :letter-spacing="'-0.5'">Publications</router-link></tspan> -->
                                    <!-- <tspan class="no-pointer star">&#8201;✳&#8201;</tspan> -->
                                    <tspan><router-link to="/about" :xlink:href="'/about'" :letter-spacing="'-0.5'">About</router-link></tspan>
                                </textPath>
                            </text>
                        </g>
                    </g>
                </g>
                <g class="centerText">
                    <!-- <text x="66" y="70" text-anchor="middle" class="logo" letter-spacing="0">lol</text> -->
                    <image x="11" y="12" href="@/assets/img/wallstreet-logo.svg" height="100" width="100"/>
                    <!-- <text x="66" y="70" text-anchor="middle" class="logo"><router-link to="/" :xlink:href="'/'">WallStreet</router-link></text> -->
                </g>
            </svg>
        </div>
    </header>
</template>

<script>

import EventBus from './../util/EventBus'
import * as types from './../store/mutation-types'

export default {
  name: 'siteHeader',
  components: {
      
  },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    isPushed: {
        type: Boolean,
        default: false
    }
  },
  data () {
    return {
      MutableIsActive: JSON.parse(this.isActive),
      MutableIsPushed: JSON.parse(this.isPushed)
    }
  },
  mounted () {
    let siteHeader = document.getElementById('siteHeader')
    EventBus.$on('physics.ballA', coord => {
      siteHeader.style.transform = 'translate(' + coord.x + 'px, ' + coord.y + 'px) rotate(' + coord.r + 'deg)'
    })


    // this.$router.afterEach((to, from) => {
    //     if (this.MutableIsActive) {
    //         this.MutableIsActive = false
    //         EventBus.$emit('siteHeader.leave')
    //     }
    // })

  },
  created () {
      if (this.$store.getters.getIsMobile) {
        document.addEventListener('touchstart', this.documentClick)
      } else {
        document.addEventListener('click', this.documentClick)
      }
  },
  destroyed () {
    // important to clean up!!
    if (this.$store.getters.getIsMobile) {
        document.removeEventListener('touchstart', this.documentClick)
    } else {
        document.removeEventListener('click', this.documentClick)
    }
  },
  methods: {
      onEnter () {
          if (!this.$store.getters.getIsMobile) {
            this.MutableIsActive = true
            this.$store.commit(types.UPDATE_PHYSICS, { field: 'siteHeader', value: 'big' })
          }
      },
      onLeave () {
          if (!this.$store.getters.getIsMobile) {
            this.MutableIsActive = false
            this.$store.commit(types.UPDATE_PHYSICS, { field: 'siteHeader', value: 'small' })
          }
      },
      onClick () {
        // if (this.$store.getters.getIsMobile) {
        //     if (this.MutableIsActive) {
        //         this.MutableIsActive = false
        //         this.$store.commit(types.UPDATE_PHYSICS, { field: 'siteHeader', value: 'small' })
        //     } 
        //     // else {
        //     //     this.MutableIsActive = true
        //     //     EventBus.$emit('siteHeader.enter')
        //     // }
        // } 
      },
      documentClick (e) {
        let el = this.$refs.svgPill
        let el2 = this.$refs.pillInteraction
        let target = e.target
        if ( el !== target && !el.contains(target) && el2 !== target && !el2.contains(target) )  {
            if (this.MutableIsActive) {
                this.MutableIsActive = false
                this.MutableIsPushed = false
                this.$store.commit(types.UPDATE_PHYSICS, { field: 'siteHeader', value: 'small' })
            }
        }
      },
      onTouchStart () {
          this.MutableIsPushed = true
            if (!this.MutableIsActive) {
                EventBus.$emit('siteHeader.stop')
            }

      },
      onTouchEnd () {
          this.MutableIsPushed = false
            if (!this.MutableIsActive) {
                this.MutableIsActive = true
                this.$store.commit(types.UPDATE_PHYSICS, { field: 'siteHeader', value: 'big' })
            } else if (this.MutableIsActive) {
                this.MutableIsActive = false
                this.$store.commit(types.UPDATE_PHYSICS, { field: 'siteHeader', value: 'small' })

            }

      },
      onTouchEndOutside () {
            this.MutableIsPushed = false
            if (this.MutableIsActive) {
                this.MutableIsActive = false
                this.$store.commit(types.UPDATE_PHYSICS, { field: 'siteHeader', value: 'small' })

            }

      },
      onMouseDown () {
          this.MutableIsPushed = true
      },
      onMouseUp () {
          this.MutableIsPushed = false
      }
  }
}
</script>

<style lang="scss" scoped>
    .svgContainer.is-active {
      z-index: 1500;
      image {
        transform: scale(0.65);
      }
    }
    .is-ie .svgContainer {
    	top: 50%;
    	left: 50%;
    }
    image {
      transform: scale(0.8);
      transition: transform 0.4s ease;
      transform-origin: 50% 50%;
    }
</style>
